import React from "react";
import { observer } from "mobx-react";
import useDocumentTitle from "../layout/title";
import Literal from "../input/Literal";
import RichLiteral from "../input/RichLiteral";
import { Box, Button, Grid, Skeleton } from "@mui/material";
import { toast } from "react-toastify";

export default observer(({ data }) => {
  useDocumentTitle("Quote");
  if (data === null) {
    return <Skeleton />;
  }

  return (
    <Box m={1} p={1} style={{ background: "white" }}>
      <h1>
        if there's no quote Nr then the Quote is beeing made please refresh
      </h1>
      <Grid container spacing={1}>
        <Grid item xs={12} md={3}>
          <Literal
            title="QuoteNr SAP"
            text={data.quoteNr !== "" ? data.quoteNr : "NOT SET"}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Literal title="SAP System" text={data.sapSys} />
        </Grid>
        <Grid item xs={12} md={3}>
          <Literal
            title="Action"
            text={data.sapAction + " from: " + data.Data.Quotenr}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Literal title="Sales Org" text={data.Data.Salesorg} />
        </Grid>
        <Grid item xs={12} md={6}>
          <RichLiteral title="Description" text={data.description} />
        </Grid>
        <Grid item xs={12}>
          {data.quoteNr === "" && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={(e) => {
                toast("TODO");
              }}
            >
              Retry
            </Button>
          )}
        </Grid>
      </Grid>
    </Box>
  );
});
